<template>
  <a
    class="inline-flex items-center px-2 space-x-1 -mx-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 hover:text-gray-500 active:text-gray-600 dark:hover:bg-gray-900"
    :class="{
      'rounded-lg': !rounded,
      'rounded-full': rounded,
    }"
  >
    <slot />

    <ExternalLinkIcon v-if="withIcon" />
  </a>
</template>

<script setup>
import { ref } from 'vue'
import ExternalLinkIcon from "../Icons/ExternalLinkIcon.vue";

const copied = ref(false)

const props = defineProps({
  rounded: { type: Boolean, default: true },
  withIcon: { type: Boolean, default: true },
})
</script>
